import { render } from "./LegendPanel.vue?vue&type=template&id=7e627e66&scoped=true"
import script from "./LegendPanel.vue?vue&type=script&lang=js"
export * from "./LegendPanel.vue?vue&type=script&lang=js"

import "./LegendPanel.vue?vue&type=style&index=0&id=7e627e66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e627e66"]])

export default __exports__